export const MIN_QUANTITY = 1
export const MAX_QUANTITY = 99
